import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getJourneyList, showProgress } from '../../../redux/actions/DealershipActions';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import service from '../../../apis/service';

const useFetchData = () => {
  const dispatch = useDispatch();

  const fetchJourneys = useCallback(async () => {
    dispatch(showProgress(true));
    const res = await service.get(apiEndpoints.GET_JOURNEYS);
    dispatch(getJourneyList('fetch', res));
    dispatch(showProgress(false));
  }, [dispatch]);

  return {
    fetchJourneys,
  };
};

export default useFetchData;
